import { isEmpty } from 'mc-ui-utils';
import State from '../state';
import BubbleEvent from './BubbleEvent';
import ImpressionEvent from './ImpressionEvent';
export default class BubbleEventFactory {
    constructor() {
        this.impressions = {};
    }
    createEvents(bubble, position) {
        try {
            const { glances } = bubble;
            this.bubbleEvent = new BubbleEvent(bubble.id, position, glances.length);
            State.loadedBubbles.add(bubble.id);
            glances.forEach((highlight, index) => {
                this.impressions[highlight.glanceId] = new ImpressionEvent(highlight.glanceId, this.bubbleEvent.bubbleImpressionId, index);
                State.loadedGlances.add(highlight.glanceId);
            });
        }
        catch (err) {
            console.error(err);
        }
    }
    resetEvent() {
        var _a;
        (_a = Object.keys(this.impressions)) === null || _a === void 0 ? void 0 : _a.map((key) => {
            this.impressions[key].reset();
        });
    }
    setBubbleShown(source, glanceId, glancesShown) {
        this.bubbleEvent.setShown(source, glanceId, glancesShown);
        this.setGlanceShown(glanceId, source);
        State.seenBubles.add(this.bubbleEvent.bubbleId);
    }
    setGlanceShown(glanceId, source) {
        if (!isEmpty(this.impressions[glanceId])) {
            if (isEmpty(this.impressions[glanceId].glanceStartedTime)) {
                this.bubbleEvent.setGlanceSeen();
                this.impressions[glanceId].setStart(source);
            }
            State.seenGlances.add(glanceId);
            this.impressions[glanceId].setShown();
        }
    }
    setGlanceInteracted(glanceId) {
        if (isEmpty(this.impressions[glanceId].ctaEvent)) {
            this.bubbleEvent.setGlanceInteracted();
        }
        State.interactedGlances.add(glanceId);
    }
    setImpressionEnd(glanceId, source, isVideoGlance = false) {
        try {
            this.bubbleEvent.setFinished(source, glanceId);
            this.bubbleEvent.fireEvent();
            this.setGlanceImpressionEnd(glanceId, source, isVideoGlance);
        }
        catch (err) {
            console.error(err);
        }
    }
    setGlanceIsHolding(glanceId) {
        if (!isEmpty(this.impressions[glanceId])) {
            this.impressions[glanceId].setIsHolding();
        }
    }
    setGlanceMoreOpen(glanceId) {
        if (!isEmpty(this.impressions[glanceId])) {
            this.impressions[glanceId].setMoreOptions();
        }
    }
    setGlanceFinishedHolding(glanceId) {
        if (!isEmpty(this.impressions[glanceId])) {
            this.impressions[glanceId].setFinishedHolding();
        }
    }
    setGlanceLikeState(glanceId, likeState) {
        if (!isEmpty(this.impressions[glanceId])) {
            this.impressions[glanceId].setLikeDetails(likeState);
        }
    }
    setGlanceShared(glanceId, shareSource) {
        if (!isEmpty(this.impressions[glanceId])) {
            this.impressions[glanceId].setShareDetails(shareSource);
        }
    }
    setGlanceVideoDetails(glanceId, videoEvent) {
        const impressionEvent = this.impressions[glanceId];
        if (!isEmpty(impressionEvent)) {
            impressionEvent.setVideoDetails(videoEvent);
            // in case of videos the videoDetails comes from Video component and endsource comes from parent Glance component, hence this check
            if (!isEmpty(impressionEvent.glanceEndSource)) {
                impressionEvent.fireEvent();
            }
        }
    }
    setGlanceCTADetails(glanceId, duration, failureCount, loadTime, ctaTime) {
        this.impressions[glanceId].setCTADetails(duration, failureCount, loadTime, ctaTime);
    }
    setGlanceImpressionEnd(glanceId, source, isVideoGlance = false) {
        try {
            const impressionEvent = this.impressions[glanceId];
            if (!isEmpty(impressionEvent)) {
                impressionEvent.setFinished(source);
                if (!isVideoGlance ||
                    (isVideoGlance && !isEmpty(impressionEvent.videoEvent))) {
                    impressionEvent.fireEvent();
                }
            }
        }
        catch (err) {
            console.error(err);
        }
    }
}
//# sourceMappingURL=EventFactory.js.map